import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiSmartButtonAPIKey: PluginKey = new PluginKey('aiSmartButtonAPI');
